export const parseJson = (data) => {
  try {
    return JSON.parse(data);
  } catch (err) {
    return undefined;
  }
};

export function jsonUtils(str) {
  try {
    return JSON.parse(str) && true;
  } catch (e) {
    return false;
  }
}

export function jsToString(data) {
  if (Array.isArray(data)) {
    return data.map((item) => {
      const obj = {};
      Object.keys(item).forEach((subItem) => {
        if (typeof item[subItem] !== 'string' && item[subItem]) {
          obj[subItem] = JSON.stringify(item[subItem]);
        } else {
          obj[subItem] = item[subItem];
        }
      });
      return obj;
    });
  }
  return JSON.stringify(data);
}
